
<modal
  :title="editing ? 'Edit saved search' : 'Save search'"
  :open="open"
  @close="closeModal"
>
  <p>Review and give your custom search a name.</p>

  <form @submit.stop.prevent="save">
    <text-input
      ref="nameInput"
      v-model.trim="name"
      label="Name"
      required
      maxlength="80"
    />

    <div v-if="query" class="grid">
      <div>Search term:</div>
      <strong>{{ editing ? editing.query : query }}</strong>
    </div>

    <div v-if="filterDescription" class="grid">
      <div>Filters:</div>
      <strong>{{ filterDescription }}</strong>
    </div>

    <btn
      type="submit"
      :loading="saving"
      :disabled="!name.trim()"
    >
      Save
    </btn>
  </form>
</modal>
